import { PanelType } from '../../../../panels/types';

export interface DependenciesPanelData {
  metadataElementId: string;
  crmOrgId: string;
  color?: string;
}

export const dependenciesPanelType: PanelType<DependenciesPanelData> = {
  name: 'DEPENDENCIES_PANEL',
  location: 'left',
}; 
